// extracted by mini-css-extract-plugin
module.exports = {"popUp":"ModalPopUp_SA_popUp__2pCog","shadow":"ModalPopUp_SA_shadow__3gGWa","rounded":"ModalPopUp_SA_rounded__1uZ2x"};